import dayjs from 'dayjs';

type ObjectWithDatetime<K extends string> = Partial<{
  [k in K]: string | null;
}>;

export function sortByDatetime<
  K extends string,
  O extends ObjectWithDatetime<K>,
>(key: K, entries: O[], desc = false) {
  return [...entries].sort((a, b) => {
    const aValue = a[key];
    const bValue = b[key];

    // Safety fallback: If either value is missing, prevent a crash
    if (!aValue && !bValue) return 0;
    if (!aValue) return desc ? -1 : 1; // Pushes empty dates to the bottom
    if (!bValue) return desc ? 1 : -1;

    // Convert both to timestamps (milliseconds)
    const timeA = dayjs(aValue).valueOf();
    const timeB = dayjs(bValue).valueOf();

    return desc ? timeB - timeA : timeA - timeB;
  });
}
